import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProgressMasterStoreActions,
  ProgressMasterStoreSelectors,
  ProgressMasterStoreReducer,
} from './index';
import { ProgressReportMasterDto } from '@cradua/data';

@Injectable()
export class ProgressMasterFacade {
  constructor(
    private store: Store<ProgressMasterStoreReducer.ProgressMasterPartialState>
  ) {}

  projectManagementRecord$ = this.store.select(
    ProgressMasterStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ProgressMasterStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    ProgressMasterStoreSelectors.getProgressMasterError
  );

  getselected() {
    return this.store.select(ProgressMasterStoreSelectors.getSelected);
  }

  get isLoadingProgressMaster() {
    this.store.dispatch(ProgressMasterStoreActions.loadProgressMaster());
    return this.store.select(
      ProgressMasterStoreSelectors.loadingProgressMaster
    );
  }

  get loadProgressMaster() {
    this.store.dispatch(ProgressMasterStoreActions.loadProgressMaster());
    return this.store.select(ProgressMasterStoreSelectors.getAllProgressMaster);
  }

  searchProgressMasterRecord(query) {
    this.store.dispatch(
      ProgressMasterStoreActions.searchProgressMasterRecord({ query })
    );
  }

  addProgressMaster(newProgressMaster: ProgressReportMasterDto[]) {
    this.store.dispatch(
      ProgressMasterStoreActions.addProgressMaster({
        newProgressMaster,
      })
    );
  }

  updateProgressMaster(updateProgressMaster: ProgressReportMasterDto[]) {
    this.store.dispatch(
      ProgressMasterStoreActions.updateProgressMaster({
        updateProgressMaster,
      })
    );
  }

  removeProgressMaster(ids: string[]) {
    this.store.dispatch(
      ProgressMasterStoreActions.removeProgressMaster({ ids })
    );
  }
}
